import { css, Theme } from '@emotion/react'

export const getAsHtmlBaseStyles = (theme: Theme) => css`
  overflow-wrap: anywhere;

  * {
    max-width: 100%;
  }

  // CONTENT STYLES - same as on the CMS side - Editor
  a {
    color: ${theme.colors.blue};
    text-decoration: none;
    cursor: pointer;
  }

  sup {
    display: inline-block;
    margin-top: -10px;
  }

  sub {
    display: inline-block;
    margin-bottom: -10px;
  }

  & > :first-child {
    margin-top: 0;
  }

  & > :last-child {
    margin-bottom: 0;
  }

  .ql-align-right {
    text-align: right;
  }

  .ql-align-center {
    text-align: center;
  }

  .ql-align-justify {
    text-align: justify;
  }

  // default font
  font-size: 14px;
  line-height: 20px;

  .text-tiny {
    font-size: 10px !important;
    line-height: 14px !important;
  }

  .text-small {
    font-size: 12px !important;
    line-height: 16px !important;
  }

  .text-big {
    font-size: 16px !important;
    line-height: 28px !important;
  }

  .text-huge {
    font-size: 18px !important;
    line-height: 34px !important;
  }

  .text-blog-title {
    font-size: 22px !important;
    line-height: 34px !important;
  }

  .text-subtitle {
    font-weight: 700 !important;
  }

  h4 {
    font-size: 48px !important;
    line-height: 60px !important;
    margin: 14px 0 !important;
  }

  h3 {
    font-size: 54px !important;
    line-height: 68px !important;
    margin: 14px 0 !important;
  }

  h2 {
    font-size: 64px !important;
    line-height: 81px !important;
    margin: 14px 0 !important;
  }

  // custom bar styles
  .bar {
    display: inline-block;
    width: 100%;
    padding: 11px;
    text-align: center;
    font-weight: 700;
    border-radius: 12px;
    font-size: 16px;
    line-height: 22px;
  }

  // default styles from editor for figure, .todo-list, table, blockquote & pre
  figure {
    margin-left: auto;
    margin-right: auto;
    width: fit-content;

    &.image-style-side {
      margin-right: 0;
    }
  }

  .image_resized img {
    width: 100%;
  }

  // youtube or vimeo video wrapper
  figure:has(div[data-oembed-url]) {
    width: 100%;

    div[data-oembed-url] {
      width: 100%;
    }
  }

  // math and chemistry formulas
  math {
    font-family: ${theme.fonts.family.CambriaMath};
  }

  // standalone formula paragraphs: scroll instead of clipping on small screens
  p:has(> math:only-child) {
    max-width: 100%;
    overflow-y: hidden;
    overflow-x: auto;

    > math:only-child {
      max-width: none; // override * { max-width: 100% }
    }
  }

  .todo-list {
    list-style: none;

    li {
      position: relative;
      margin-bottom: 5px;

      input {
        position: absolute;
        left: -25px;
      }
    }
  }

  table {
    height: 100%;
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
  }

  blockquote {
    border-left: 5px solid #ccc;
    font-style: italic;
    margin-left: 0;
    margin-right: 0;
    overflow: hidden;
    padding-left: 1.5em;
    padding-right: 1.5em;
  }

  pre {
    display: block;
    font-family: monospace;
    margin: 1em 0;
    background: hsla(0, 0%, 78%, 0.3);
    border: 1px solid #c4c4c4;
    border-radius: 2px;
    color: #353535;
    direction: ltr;
    font-style: normal;
    min-width: 200px;
    padding: 1em;
    tab-size: 4;
    text-align: left;
    white-space: pre-wrap;
  }
`
